import {
	ResponsiveContainer,
	XAxis,
	YAxis,
	ScatterChart,
	Scatter,
	Label,
} from "recharts";

import React, { useState, useEffect } from "react";

import { numberFormatter } from "../../utils";

const intervalValues = [
	"Insulated",
	"45_Degree_Configuration",
	"Lug",
	"Trade_Size",
	"Non_Angular",
	"China",
	"Duplex_Cable_Connector",
	"SnapIn_Cable_Connector",
];

const AttributeScatter = (props: any) => {
	const [data, setData] = useState([]);

	useEffect(() => {
		if (props.attributeList) {
			setData(props.attributeList.scatterData);
		}
	}, [props]);

	return (
		<div className="w-[20vw] flex flex-col items-center h-[18vw] border-2 p-1">
			<div className="w-fit px-[1.8vh] py-[.3vh] min-w-[5vw] text-center">
				<span className="text-center text-[2vh] italic font-medium text-black">
					{props.attributeList.Attribute === "China"
						? "Country of Origin: China"
						: props.attributeList.Attribute ===
						  "SnapIn_Cable_Connector"
						? "Type: SnapIn Cable Connector"
						: props.attributeList.Attribute ===
						  "Duplex_Cable_Connector"
						? "Type: Duplex Cable Connector"
						: props.attributeList.Attribute ===
						  "45_Degree_Configuration"
						? "Configuration: 45 degree"
						: props.attributeList.Attribute.replaceAll("_", " ")}
				</span>
			</div>
			<ResponsiveContainer width="100%" height="100%">
				<ScatterChart
					width={400}
					height={400}
					margin={{
						top: 20,
						right: 20,
						bottom: 20,
						left: 30,
					}}
				>
					<XAxis
						type="number"
						dataKey="price"
						stroke="black"
						tickFormatter={(val) => numberFormatter(val, 0, "$")}
						tick={{ fontSize: "2vh" }}
					>
						<Label
							value="Cost Price"
							offset={0}
							position="bottom"
							style={{ fill: "black", fontSize: "2vh" }}
						/>
					</XAxis>
					<YAxis
						type="number"
						dataKey="val"
						stroke="black"
						interval={
							intervalValues?.includes(
								props.attributeList.Attribute
							)
								? 3
								: 0
						}
						tickFormatter={(val) => numberFormatter(val, 0)}
						tick={{ fontSize: "2vh" }}
					>
						<Label
							value={`${
								props.attributeList.Attribute ===
								"Trade_Size_square"
									? `Trade Size (inch sqaure)`
									: props.attributeList.Attribute === "Weight"
									? "Weight (lbs per 100 units)"
									: props.attributeList.Attribute.replaceAll(
											"_",
											" "
									  )
							}`}
							angle={-90}
							offset={0}
							position="insideLeft"
							style={{
								fill: "black",
								textAnchor: "middle",
								fontSize: "2vh",
							}}
						/>
					</YAxis>

					{data?.map((d: any, index: number) => {
						return (
							<Scatter
								key={index}
								data={[d]}
								fill={"#056FAD"}
								name={props.Attribute}
							></Scatter>
						);
					})}
				</ScatterChart>
			</ResponsiveContainer>
			{/* <span className="italics text-[#86bc25]">*Note: The above data is only for top 250 suppliers by spend </span> */}
		</div>
	);
};

export default AttributeScatter;
